import moment from 'moment'

const getAppointmentEnd = (start?: string, duration: string | number = 0): string => {
  return moment.utc(start).add(duration, 'minutes').format('YYYY-MM-DDTHH:mmZ')
}

export default getAppointmentEnd
